var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar3 = function SvgDefaultAvatar3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_3_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_3_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 55.7c6.4 0 11.1-4.5 11.1-9.7 0-4.2-2.7-7.4-7.3-8.2 3.4-2 5.1-4.1 5.1-6.7 0-3.8-3.4-6.5-8.1-6.5-3.7 0-6.5 2-8 4-.6.8-1 1.6-1 2.3 0 .7.5 1.2 1.1 1.2.5 0 .9-.4 1.5-1 1-1.3 2.5-3.1 5.2-3.1 2.6 0 4.2 1.9 4.2 4.1 0 2.5-2.3 4.5-5.8 6.3-.8.4-1.3.5-1.3 1.4s.6 1.7 1.3 1.7c.7 0 1.3-.5 2.6-.5 2.8 0 5.5 2.1 5.5 5.5 0 3.2-2.6 6-6.8 6-2.2 0-3.9-.7-5.2-1.4-1-.5-1.6-1-2.3-1-.6 0-1.1.5-1.1 1.3s.9 1.7 2.2 2.5c1.8.9 4.3 1.8 7.1 1.8z"
  })));
};
export default SvgDefaultAvatar3;